export const ctaClicked = {
  name: "cta_clicked",
  attributes: {
    pageName: "page_name",
    ctaName: "cta_name",
    optionSelected: "option_selected",
    containsImage: "contains_image",
    contentId: "content_id",
    postType: "post_type",
    source: "source_page",
    subcategory: "subcategory",
    isRecommended: "description",
    recommendedType: "status",
    section: "section",
    position: "destination",
  },
};

export const hamburgerMenuClicked = {
  name: "hamburger_menu_clicked",
  attributes: {
    pageName: "page_name",
    source: "source_page",
  },
};

export const hamburgerElementClicked = {
  name: "hamburger_element_clicked",
  attributes: {
    elementType: "element_type",
    elementName: "element_name",
    pageName: "page_name",
    source: "source_page",
  },
};

export const createPostClicked = {
  name: "write_post_clicked",
  attributes: {
    pageName: "page_name",
    source: "source_page",
  },
};

export const postPublished = {
  name: "post_published",
  attributes: {
    postType: "post_type",
    containsImage: "contains_image",
    containsVideo: "contains_video",
    containsTags: "tags_added",
    source: "source_page",
  },
};

export const postPreviewed = {
  name: "post_previewed",
  attributes: {
    postType: "post_type",
    containsImage: "contains_image",
    containsVideo: "contains_video",
    containsTags: "tags_added",
    source: "source_page",
  },
};
export const popupViewed = {
  name: "popup_viewed",
  attributes: {
    pageName: "page_name",
    popupName: "popup_name",
    source: "source_page",
    subcategory: "subcategory",
  },
};

export const popupClicked = {
  name: "popup_clicked",
  attributes: {
    pageName: "page_name",
    popupName: "popup_name",
    optionClicked: "option_selected",
    source: "source_page",
    subcategory: "subcategory",
  },
};

export const challengeClicked = {
  name: "challenge_clicked",
  attributes: {
    pageName: "page_name",
    challengeName: "challenge_name",
    source: "source_page",
  },
};

export const taskClicked = {
  name: "task_started",
  attributes: {
    pageName: "page_name",
    taskName: "task_name",
    source: "source_page",
  },
};

export const rewardShared = {
  name: "reward_shared",
  attributes: {
    pageName: "page_name",
    rewardName: "reward_name",
    source: "source_page",
  },
};

export const rewardClaimed = {
  name: "reward_claimed",
  attributes: {
    pageName: "page_name",
    rewardName: "reward_name",
    source: "source_page",
  },
};

export const promoCopied = {
  name: "promo_copied",
  attributes: {
    pageName: "page_name",
    rewardName: "reward_name",
    promoCodeName: "promo_code",
    source: "source_page",
  },
};

export const interestsAdded = {
  name: "interests_added",
  attributes: {
    pageName: "page_name",
    optionSelected: "option_selected",
    source: "source_page",
  },
};

export const alertViewed = {
  name: "alert_viewed",
  attributes: {
    pageName: "page_name",
    alertType: "alert_type",
    source: "source_page",
  },
};

export const alertClicked = {
  name: "alert_clicked",
  attributes: {
    pageName: "page_name",
    alertType: "alert_type",
    source: "source_page",
  },
};

export const postViewed = {
  name: "post_viewed",
  attributes: {
    pageName: "page_name",
    postType: "post_type",
    contentId: "content_id",
    section: "section",
    source: "source_page",
    subcategory: "subcategory",
    isRecommended: "description",
    recommendedType: "status",
    position: "destination",
  },
};

export const postLiked = {
  name: "post_liked",
  attributes: {
    pageName: "page_name",
    postType: "post_type",
    contentId: "content_id",
    source: "source_page",
    subcategory: "subcategory",
    isRecommended: "description",
    recommendedType: "status",
    position: "destination",
  },
};

export const postCommented = {
  name: "post_commented",
  attributes: {
    pageName: "page_name",
    postType: "post_type",
    contentId: "content_id",
    commentType: "comment_type",
    infoType: "info_type",
    source: "source_page",
    subcategory: "subcategory",
    isRecommended: "description",
    recommendedType: "status",
    position: "destination",
  },
};

export const postShared = {
  name: "post_shared",
  attributes: {
    postType: "post_type",
    contentId: "content_id",
    shareType: "share_type",
    source: "source_page",
    subcategory: "subcategory",
    isRecommended: "description",
    recommendedType: "status",
    position: "destination",
  },
};

export const postReported = {
  name: "post_reported",
  attributes: {
    contentId: "content_id",
    optionSelected: "option_selected",
    source: "source_page",
    subcategory: "subcategory",
    isRecommended: "description",
    recommendedType: "status",
  },
};

export const postSaved = {
  name: "post_saved",
  attributes: {
    postType: "post_type",
    contentId: "content_id",
    source: "source_page",
    subcategory: "subcategory",
    isRecommended: "description",
    recommendedType: "status",
    position: "destination",
  },
};

export const pollAnswered = {
  name: "poll_answered",
  attributes: {
    pageName: "page_name",
    contentId: "content_id",
    optionSelected: "option_selected",
    source: "source_page",
    subcategory: "subcategory",
    isRecommended: "description",
    recommendedType: "status",
    position: "destination",
  },
};

export const profileClicked = {
  name: "profile_clicked",
  attributes: {
    contentId: "content_id",
    source: "source_page",
    subcategory: "subcategory",
  },
};

export const contentExhausted = {
  name: "content_exhausted",
  attributes: {
    pageName: "page_name",
    source: "source_page",
  },
};

export const postTypeFiltered = {
  name: "post_type_filtered",
  attributes: {
    pageName: "page_name",
    filterType: "option_selected",
    source: "source_page",
    brand: "card_name",
  },
};

export const homePageRefreshed = {
  name: "home_page_refreshed",
  attributes: {
    pageName: "page_name",
    filterType: "option_selected",
    source: "source_page",
  },
};

export const cardViewed = {
  name: "card_viewed",
  attributes: {
    pageName: "page_name",
    cardName: "card_name",
    source: "source_page",
  },
};

export const cardClicked = {
  name: "card_clicked",
  attributes: {
    pageName: "page_name",
    cardName: "card_name",
    source: "source_page",
    subcategory: "subcategory",
  },
};

export const pageLoaded = {
  name: "page_loaded",
  attributes: {
    pageName: "page_name",
    source: "source_page",
    contentId: "content_id",
    subcategory: "subcategory",
    section: "section",
    position: "destination",
    brand: "card_name",
  },
};

export const searchClicked = {
  name: "search_clicked",
  attributes: {
    pageName: "page_name",
    source: "source_page",
  },
};

export const searchSubmitted = {
  name: "search_submitted",
  attributes: {
    keyword: "keyword",
    searchType: "search_type",
    source: "source_page",
  },
};

export const searchSuggestedPostClicked = {
  name: "search_suggested_post_clicked",
  attributes: {
    keyword: "keyword",
    contentId: "content_id",
    source: "source_page",
  },
};

export const editProfileClicked = {
  name: "edit_profile_clicked",
  attributes: {
    pageName: "page_name",
    source: "source_page",
  },
};

export const profileSaved = {
  name: "page_name",
  attributes: {
    pageName: "page_name",
    source: "source_page",
  },
};

export const profileChecklistClicked = {
  name: "profile_checklist_clicked",
  attributes: {
    pageName: "page_name",
    optionSelected: "option_selected",
    source: "source_page",
  },
};

export const primaryGuidelineClick = {
  name: "primary_guidelines_clicked",
  attributes: {
    pageName: "page_name",
    guidelineName: "guideline_name",
    source: "source_page",
  },
};

export const secondaryGuidelineClick = {
  name: "secondary_guidelines_clicked",
  attributes: {
    pageName: "page_name",
    guidelineName: "guideline_name",
    source: "source_page",
  },
};

export const scHomePageScrolled = {
  name: "home_page_scrolled",
  attributes: {
    scrollDepth: "scroll_depth",
    source: "source_page",
    subcategory: "subcategory",
  },
};

export const tagClicked = {
  name: "tag_clicked",
  attributes: {
    tagName: "tag_name",
    source: "source_page",
  },
};

export const postViewedImpression = {
  name: "post_viewed_impression",
  attributes: {
    section: "section",
    contentId: "content_id",
    source: "source_page",
    subcategory: "subcategory",
    isRecommended: "description",
    recommendedType: "status",
    position: "destination",
  },
};

export const bannerViewed = {
  name: "banner_viewed",
  attributes: {
    section: "section",
    pageName: "page_name",
    source: "source_page",
  },
};

export const widgetViewed = {
  name: "widget_viewed",
  attributes: {
    section: "section",
    pageName: "page_name",
    widgetIndex: "widget_index",
    cardIndex: "card_index",
    cardDay: "card_day",
  },
};

export const iconClicked = {
  name: "icon_clicked",
  attributes: {
    section: "section",
    pageName: "page_name",
    optionSelected: "option_selected",
  },
};

export const bannerClicked = {
  name: "banner_clicked",
  attributes: {
    pageName: "page_name",
    category: "category",
    optionSelected: "option_selected",
  },
};

export const postClicked = {
  name: "post_card_clicked",
  attributes: {
    pageName: "page_name",
    postType: "post_type",
    contentId: "content_id",
    section: "section",
    source: "source_page",
    subcategory: "subcategory",
    isRecommended: "description",
    recommendedType: "status",
  },
};

export const postMediaClicked = {
  name: "post_media_clicked",
  attributes: {
    postType: "post_type",
    contentId: "content_id",
    containsImage: "contains_image",
    containsVideo: "contains_video",
    source: "source_page",
    subcategory: "subcategory",
    isRecommended: "description",
    recommendedType: "status",
    position: "destination",
  },
};

export const postViewForFiveSec = {
  name: "post_viewed_five_sec",
  attributes: {
    section: "section",
    contentId: "content_id",
    source: "source_page",
    subcategory: "subcategory",
    isRecommended: "description",
    recommendedType: "status",
    position: "destination",
  },
};

export const discoverPageLoaded = {
  name: "dis_session_started",
  attributes: {},
};

export const discoverSectionLoaded = {
  name: "dis_section_loaded",
  attributes: {
    title: "source_page",
  },
};

export const disCardClicked = {
  name: "dis_card_clicked",
  attributes: {
    cardType: "card_type",
    title: "card_name",
    cardId: "card_id",
    section: "section",
    page: "page",
    source: "source",
    scrollDepth: "scroll_depth",
  },
};

export const cardOpened = {
  name: "dis_card_opened",
  attributes: {
    cardType: "card_type",
    title: "card_name",
    cardId: "card_id",
    section: "section",
    page: "page",
    source: "source",
  },
};

export const savedBtnClicked = {
  name: "dis_saved_clicked",
  attributes: {},
};

export const savedItemClick = {
  name: "dis_saved_item_viewed",
  attributes: {
    cardId: "card_id",
    parentId: "component_id",
    uiType: "card_type",
    title: "card_name",
  },
};

export const buttonClicked = {
  name: "dis_element_clicked",
  attributes: {
    uiType: "card_type",
    cardId: "card_id",
    title: "card_name",
    element: "element",
    section: "section",
    page: "page",
    source: "source",
    scrollDepth: "scroll_depth",
  },
};

export const homePageScrolled = {
  name: "discover_home_page_scrolled",
  attributes: {
    distanceScrolled: "card_positioning",
    percentageScrolled: "minimum_distance",
  },
};

export const cardClosed = {
  name: "dis_card_closed",
  attributes: {
    cardId: "card_id",
    parentId: "component_id",
    uiType: "card_type",
  },
};

export const disCoverCardViewed = {
  name: "discover_card_viewed",
  attributes: {
    cardId: "card_id",
    parentId: "component_id",
    uiType: "card_type",
    title: "card_name",
  },
};

export const storySwipe = {
  name: "dis_story_swipe",
  attributes: {
    cardId: "card_id",
    parentId: "component_id",
    title: "card_name",
  },
};
export const nextStory = {
  name: "dis_insight_next_segment",
  attributes: {
    cardId: "card_id",
    parentId: "component_id",
    title: "card_name",
  },
};

export const interestsViewed = {
  name: "dis_interests_viewed",
  attributes: {
    page: "page",
    source: "source",
    element: "element",
  },
};

export const interestsSubmitted = {
  name: "dis_interests_submitted",
  attributes: {
    page: "page",
    source: "source",
    element: "element",
  },
};

export const searchRecentsClicked = {
  name: "dis_search_recents_clicked",
  attributes: {
    element: "element",
    page: "page",
    source: "source",
  },
};

export const disSearchSubmitted = {
  name: "dis_search_submitted",
  attributes: {
    element: "element",
    page: "page",
    source: "source",
  },
};

export const videoWatched = {
  name: "dis_video_watched",
  attributes: {
    cardType: "card_type",
    title: "card_name",
    cardId: "card_id",
    section: "section",
    page: "page",
    source: "source",
    duration: "video_duration",
  },
};

export const disCardViewed = {
  name: "dis_card_viewed",
  attributes: {
    uiType: "card_type",
    cardId: "card_id",
    title: "card_name",
    section: "section",
    page: "page",
    source: "source",
    scrollDepth: "scroll_depth",
  },
};

export const scoreCardGenerated = {
  name: "dis_quiz_scorecard_generated",
  attributes: {
    uiType: "card_type",
    cardId: "card_id",
    title: "card_name",
    section: "section",
    page: "page",
    source: "source",
    scrollDepth: "scroll_depth",
    position: "position",
  },
};

export const extraRewardClaimed = {
  name: "cta_clicked",
  attributes: {
    page: "page",
    section: "section",
  },
};

export const claimNowBannerClick = {
  name: "cta_clicked",
  attributes: {
    page: "page",
    section: "section",
  },
};
